import classnames from "classnames";
import React from "react";

import { SvgComponent } from "common/types/images";

import styles from "./Icon.module.scss";

export type IconType = SvgComponent | string;

type Props = {
  icon: IconType;
  className?: string;
};
// Used to manage different types of icons before we make their implementation more uniform

export default function Icon({ icon, className }: Props) {
  if (shouldUseSvg(icon)) {
    const Icon = icon;
    return <Icon className={classnames(styles.icon, className)} />;
  } else if (shouldUseFa(icon as string)) {
    return <i className={classnames(styles.iconFont, className, icon)} />;
  } else
    return (
      <img
        src={icon as string}
        alt=""
        className={classnames(styles.icon, className)}
      />
    );
}

function shouldUseSvg(icon: IconType): boolean {
  return typeof icon === "function";
}

function shouldUseFa(icon: string): boolean {
  return icon.startsWith("fa");
}
